export default __webpack_public_path__ + "static/media/download.d28c490d.svg";